import React from 'react';
import isEqual from 'underscore/modules/isEqual';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';
import { getLines, getMapDistance } from '../../../../utils/at_map_helpers';
import { saveAtMap } from '../../../../utils/requests/at_map_requests';

const createReactClass = require('create-react-class');

const VerifiedRouteContributeItem = createReactClass({
  getInitialState() {
    return {
      trailPlannerActive: false,
      showInstructions: false
    };
  },
  componentDidUpdate(prevProps) {
    // Has GPX been uploaded (/trail/new)?
    if (!isEqual(prevProps.mapModel, this.props.mapModel)) {
      this.disableTrailPlanner();
    }
  },
  componentWillUnmount() {
    this.props.messagingChannel.publish('edit.disable_trail_planner');
  },
  getDistance() {
    const { routeInfo, mapModel } = this.props;
    if (routeInfo) {
      return routeInfo.distance;
    }
    if (mapModel) {
      return getMapDistance(mapModel);
    }
    return 0;
  },
  isTrailNewWithGivenTrack() {
    return this.props.rapidRoute && !this.props.trail.id;
  },
  getVREditData(relationId) {
    return {
      type: 'verified_route',
      data: {
        display_text: this.formatDistance(),
        move_th_to_start_pt: 'Y',
        use_description: 'Y'
      },
      relation_id: relationId
    };
  },
  getNewEditData() {
    if (!this.state.trailPlannerActive && this.props.mapModel) {
      const defaultMap = this.props.trail.defaultMap;
      if (!defaultMap || defaultMap.id !== this.props.mapModel.id || this.isTrailNewWithGivenTrack()) {
        // If user uploaded a GPX, no need to create map before creating edit item.
        return this.getVREditData(this.props.mapModel.id);
      }
    }

    if (this.state.trailPlannerActive && this.getDistance() > 0.0 && this.props.routeInfo.hasChanged) {
      // Use the itemPostHandler callback option rather than returning an edit item.
      // This allows us to save the map, then save the edit item with the new map id,
      // without creating a synchronous block on the main JS thread.
      // Need to capture the route JSON now, because the map object holding it may not
      // be valid when the callback is called (race condition, story 103039636)
      const map = this.retainOriginalMapData(this.props.routeInfo.plannerMap, this.props.trail.defaultMap);
      return {
        itemPostHandler: this.itemPostHandler,
        itemPostHandlerData: { map }
      };
    }

    return null;
  },
  retainOriginalMapData(newMap, originalMap) {
    // Carry over specific, non-route-line data from the original map into the new one
    if (!originalMap) {
      return newMap;
    }
    const { description, rating, waypoints } = originalMap;
    return { description, rating, waypoints, ...newMap };
  },
  itemPostHandler(itemUrl, editItem, postEditItem, itemPostHandlerData) {
    const { map } = itemPostHandlerData;
    map.status = 'P';
    map.trail_id = this.props.trail.id;

    saveAtMap(map, { system_owned: 'true', detail: 'lite' })
      .then(newMap => {
        postEditItem(itemUrl, this.getVREditData(newMap.id));
      })
      .catch(e => {
        console.error('Map save failed: ', e);
      });
  },
  disableTrailPlanner() {
    if (this.state.trailPlannerActive) {
      this.props.messagingChannel.publish('edit.disable_trail_planner');
      this.setState({ trailPlannerActive: false, showInstructions: false });
    }
  },
  enableTrailPlanner(loadVerifiedRoute) {
    if (!this.state.trailPlannerActive) {
      // Get single route to load into trail planner on init (from GPX upload or editing existing verifie route)
      let route;
      if (loadVerifiedRoute && this.props.mapModel) {
        const routes = getLines(this.props.mapModel);
        if (routes.length > 0) {
          route = routes[0];
        }
      }
      // Enable and show instruction block briefly
      this.props.messagingChannel.publish('edit.enable_trail_planner', route);
      this.setState({ trailPlannerActive: true, showInstructions: true });
      setTimeout(() => {
        this.setState({ showInstructions: false });
      }, 30000); // 30 seconds
    }
  },
  handleEditClick() {
    this.enableTrailPlanner(true);
  },
  handleDrawClick() {
    this.enableTrailPlanner(false);
  },
  handleOutAndBackClick() {
    this.props.messagingChannel.publish('button.click.out_and_back');
  },
  handleReturnClick() {
    this.props.messagingChannel.publish('button.click.return');
  },
  handleReverseRouteClick() {
    this.props.messagingChannel.publish('button.click.reverse');
  },
  formatDistance(distance) {
    if (!distance) {
      distance = this.getDistance();
    }
    if (this.props.displayMetric) {
      return `Len: ${(distance > 0.0 ? distance / 1000.0 : 0.0).toFixed(1)}km`;
    }
    return `Len: ${(distance > 0.0 ? distance / 1609.344 : 0.0).toFixed(1)}mi`;
  },
  renderCancelButton() {
    if (this.props.trail.id || this.isTrailNewWithGivenTrack()) {
      return (
        <button className="option-button" onClick={this.disableTrailPlanner}>
          {StringConstantsMixin.strings.CANCEL}
        </button>
      );
    }
    return null;
  },
  renderOutAndBackButton() {
    return (
      <button
        className="option-button"
        disabled={!this.props.routeInfo || !this.props.routeInfo.rtsAvailable}
        onClick={this.handleOutAndBackClick}
        data-testid="outAndBackContribute"
        title={StringConstantsMixin.strings.TRACK_DETAIL.TOOLTIPS.OUT_AND_BACK}
      >
        {StringConstantsMixin.strings.TRACK_DETAIL.ACTIONS.OUT_AND_BACK}
      </button>
    );
  },
  renderReturnButton() {
    return (
      <button
        className="option-button"
        disabled={!this.props.routeInfo || !this.props.routeInfo.rtsAvailable}
        onClick={this.handleReturnClick}
        title={StringConstantsMixin.strings.TRACK_DETAIL.TOOLTIPS.RETURN}
      >
        {StringConstantsMixin.strings.TRACK_DETAIL.ACTIONS.RETURN}
      </button>
    );
  },
  renderReverseButton() {
    return (
      <button
        className="option-button"
        disabled={false}
        onClick={this.handleReverseRouteClick}
        title={StringConstantsMixin.strings.TRACK_DETAIL.TOOLTIPS.REVERSE}
      >
        {StringConstantsMixin.strings.TRACK_DETAIL.ACTIONS.REVERSE}
      </button>
    );
  },
  renderEditRouteButton() {
    return (
      <button className="option-button" onClick={this.handleEditClick} title={StringConstantsMixin.strings.CONTRIBUTE.EDIT_ROUTE}>
        {StringConstantsMixin.strings.CONTRIBUTE.EDIT_ROUTE}
      </button>
    );
  },
  renderDrawRouteButton(className = 'option-button') {
    return (
      <button
        className={className}
        onClick={this.handleDrawClick}
        title={StringConstantsMixin.strings.CONTRIBUTE.DRAW_ROUTE}
        data-testid="draw-route"
      >
        {StringConstantsMixin.strings.CONTRIBUTE.DRAW_ROUTE}
      </button>
    );
  },
  renderButtons() {
    const buttonsClasses = 'option-button-group';
    if (this.state.trailPlannerActive) {
      return (
        <div className={buttonsClasses}>
          {this.renderCancelButton()}
          {this.renderOutAndBackButton()}
          {this.renderReturnButton()}
          {this.renderReverseButton()}
          <br />
          <span>{this.formatDistance()}</span>
        </div>
      );
    }
    return (
      <div className={buttonsClasses}>
        {this.renderDrawRouteButton()}
        {this.renderEditRouteButton()}
      </div>
    );
  },
  renderInstructions() {
    const routeInstructions = StringConstantsMixin.strings.CONTRIBUTE.ROUTE_INSTRUCTIONS.split(StringConstantsMixin.strings.CONTRIBUTE.HERE);
    return (
      <div id="verified-route-instructions" className={this.state.showInstructions ? '' : 'hidden'}>
        {routeInstructions[0]}
        <a target="_blank" href="https://alltrails.zendesk.com/knowledge/articles/360019245911/en-us?brand_id=360001491372">
          {StringConstantsMixin.strings.CONTRIBUTE.HERE}
        </a>
        {routeInstructions[1]}
      </div>
    );
  },
  render() {
    return (
      <div>
        {this.renderButtons()}
        {this.renderInstructions()}
      </div>
    );
  }
});

export { VerifiedRouteContributeItem };
